import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import KvSImg01 from 'ui/images/top/kv_simg_01.png';
import KvSBalloonImg01 from 'ui/images/top/kv_simg_balloon_01.png';
import KvBalloonSPImg01 from 'ui/images/top/kv_simg_balloon_sp_01.png';
import KvBalloonSPImg02 from 'ui/images/top/kv_simg_balloon_sp_02.png';
import KvBalloonSPImg03 from 'ui/images/top/kv_simg_balloon_sp_03.png';
import KvBalloonSPImg04 from 'ui/images/top/kv_simg_balloon_sp_04.png';
import KvBalloonSPImg05 from 'ui/images/top/kv_simg_balloon_sp_05.png';
import KvBalloonSPImg06 from 'ui/images/top/kv_simg_balloon_sp_06.png';
import KvBalloonSPImg07 from 'ui/images/top/kv_simg_balloon_sp_07.png';
import KvBalloonSPImg08 from 'ui/images/top/kv_simg_balloon_sp_08.png';
import KvSImgSp02 from 'ui/images/top/kv_simg_02.png';
import KvSBalloonImg02 from 'ui/images/top/kv_simg_balloon_02.png';
import KvSImgPc03 from 'ui/images/top/kv_simg_03.png';
import KvSBalloonImg03 from 'ui/images/top/kv_simg_balloon_03.png';
import KvSImgSp04 from 'ui/images/top/kv_simg_04.png';
import KvSBalloonImg04 from 'ui/images/top/kv_simg_balloon_04.png';
import KVImgSp01 from 'ui/images/top/kv_sp_img_01.png';
import KVImgSp02 from 'ui/images/top/kv_sp_img_02.png';
import KVImgSp03 from 'ui/images/top/kv_sp_img_03.png';
import KVImgSp04 from 'ui/images/top/kv_sp_img_04.png';
import KVImgSp05 from 'ui/images/top/kv_sp_img_05.png';
import KVImgSp06 from 'ui/images/top/kv_sp_img_06.png';
import KVImgSp07 from 'ui/images/top/kv_sp_img_07.png';
import KVImgSp08 from 'ui/images/top/kv_sp_img_08.png';
import { mqMin } from 'utils/responsive';
import { Only } from 'ui/components/elements/Only/Only';

const KvIllust = styled.div`
    ${mqMin('NARROW')} {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 1440px;
        height: calc(100% - 70px);
    }

    @keyframes kvPoyon {
        0% {
            opacity: 0;
            transform: scale(0.8);
        }
        40% {
            transform: scale(1);
        }
        65% {
            transform: scale(0.95, 1.05);
        }
        75% {
            transform: scale(1.03, 0.97);
        }
        85% {
            transform: scale(0.98, 1.02);
        }
        90% {
            transform: scale(1.01, 0.99);
        }
        100% {
            opacity: 1;
            transform: scale(1, 1);
        }
    }
`;

const ImgContainerS01 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        top: 5.2rem;
        left: 2rem;
        width: 17rem;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
    }
`;

const ImgBalloon01 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        top: 16rem;
        left: 7rem;
        width: 8.7rem;
        opacity: 0;
        animation: kvPoyon 0.5s ease-out 0.4s forwards;
        transform-origin: bottom left;
    }
`;

const ImgContainerS02 = styled.div`
    display: block;
    position: absolute;
    top: 8rem;
    right: 3rem;
    width: 16rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
`;

const ImgBalloon02 = styled.div`
    display: block;
    position: absolute;
    top: 3.3rem;
    right: 11.5rem;
    width: 8rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;
`;

const ImgContainerS03 = styled.div`
    position: absolute;
    top: 24.5rem;
    left: 5rem;
    width: 13rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.4s forwards;
`;

const ImgBalloon03 = styled.div`
    display: block;
    position: absolute;
    top: 23.7rem;
    left: 1.5rem;
    width: 9rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 1s forwards;
    transform-origin: bottom left;
`;

const ImgContainerS04 = styled.div`
    display: block;
    position: absolute;
    top: 22rem;
    right: 1.8rem;
    width: 16.5rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.5s forwards;
`;

const ImgBalloon04 = styled.div`
    display: block;
    position: absolute;
    top: 22.6rem;
    right: 0.8rem;
    width: 9rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 1.2s forwards;
    transform-origin: bottom right;
`;

const ImgContainerSP01 = styled.div`
    top: 12rem;
    left: 2.4rem;
    width: 6.2rem;
    display: block;
    position: absolute;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        width: 12.2rem;
        left: 3.4rem;
    }
`;

const ImgBalloonSP01 = styled.div`
    display: block;
    position: absolute;
    top: 10rem;
    left: 6.3rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    ${mqMin('SP')} {
        top: 7rem;
        left: 10.3rem;
        width: 12rem;
    }
`;

const ImgContainerSP02 = styled.div`
    position: absolute;
    top: 10rem;
    right: 2rem;
    width: 8rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        right: 8rem;
        width: 15rem;
    }
`;

const ImgBalloonSP02 = styled.div`
    position: absolute;
    top: 15.5rem;
    right: 1rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;

    ${mqMin('SP')} {
        top: 19.5rem;
        right: 7.9rem;
        width: 12.5rem;
    }
`;

const ImgContainerSP03 = styled.div`
    display: block;
    position: absolute;
    top: 14rem;
    left: 5.2rem;
    width: 6rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 14rem;
        left: 8.2rem;
        width: 12rem;
    }
`;

const ImgBalloonSP03 = styled.div`
    display: block;
    position: absolute;
    top: 10.7rem;
    left: 1.5rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    ${mqMin('SP')} {
        top: 10rem;
        left: 1.9rem;
        width: 11rem;
    }
`;

const ImgContainerSP04 = styled.div`
    position: absolute;
    top: 10rem;
    right: 4rem;
    width: 7rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 12rem;
        right: 8rem;
        width: 13rem;
    }
`;

const ImgBalloonSP04 = styled.div`
    position: absolute;
    top: 14.5rem;
    right: 0.8rem;
    width: 7.2rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;

    ${mqMin('SP')} {
        top: 21rem;
        right: 5rem;
        width: 11.5rem;
    }
`;

const ImgContainerSP05 = styled.div`
    display: block;
    position: absolute;
    top: 12.2rem;
    left: 4rem;
    width: 6.5rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 12.2rem;
        left: 6rem;
        width: 12rem;
    }
`;

const ImgBalloonSP05 = styled.div`
    display: block;
    position: absolute;
    top: 8.6rem;
    left: 0.9rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    ${mqMin('SP')} {
        top: 7rem;
        left: 1rem;
        width: 11rem;
    }
`;

const ImgContainerSP06 = styled.div`
    position: absolute;
    top: 9.5rem;
    right: 7rem;
    width: 5rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 10.5rem;
        right: 14rem;
        width: 10rem;
    }
`;

const ImgBalloonSP06 = styled.div`
    position: absolute;
    top: 12.6rem;
    right: 3rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;

    ${mqMin('SP')} {
        top: 17.5rem;
        right: 9rem;
        width: 11.5rem;
    }
`;

const ImgContainerSP07 = styled.div`
    display: block;
    position: absolute;
    top: 13rem;
    left: 2.5rem;
    width: 10.5rem;
    opacity: 0;
    animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 13rem;
        left: 5.5rem;
        width: 16rem;
    }
`;

const ImgBalloonSP07 = styled.div`
    display: block;
    position: absolute;
    top: 9.3rem;
    left: 3rem;
    width: 7rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.4s forwards;
    transform-origin: bottom left;

    ${mqMin('SP')} {
        top: 7.3rem;
        left: 7rem;
        width: 10rem;
    }
`;

const ImgContainerSP08 = styled.div`
    position: absolute;
    top: 10.5rem;
    right: 2rem;
    width: 6rem;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        top: 10.5rem;
        right: 5rem;
        width: 12rem;
    }
`;

const ImgBalloonSP08 = styled.div`
    position: absolute;
    top: 14rem;
    right: 3.7rem;
    width: 7.5rem;
    opacity: 0;
    animation: kvPoyon 0.5s ease-out 0.6s forwards;
    transform-origin: bottom right;

    ${mqMin('SP')} {
        top: 19rem;
        right: 9.7rem;
        width: 11rem 135.3px;
    }
`;

const FadeWrap = styled.div<{ visible: boolean }>`
    transition: opacity 0.8s;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

const KvSpSetSwitcher: React.FC = () => {
    const SETS = [
        [
            (current: number) => (
                <ImgContainerSP01 key={`img1-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KVImgSp01} alt="イラスト1" />
                </ImgContainerSP01>
            ),
            (current: number) => (
                <ImgBalloonSP01 key={`bal1-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonSPImg01} alt="" />
                </ImgBalloonSP01>
            ),
            (current: number) => (
                <ImgContainerSP02 key={`img2-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KVImgSp02} alt="" />
                </ImgContainerSP02>
            ),
            (current: number) => (
                <ImgBalloonSP02 key={`bal2-${current}`} style={{ animationDelay: '0.45s' }}>
                    <img src={KvBalloonSPImg02} alt="" />
                </ImgBalloonSP02>
            ),
        ],
        [
            (current: number) => (
                <ImgContainerSP03 key={`img3-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KVImgSp03} alt="イラスト3" />
                </ImgContainerSP03>
            ),
            (current: number) => (
                <ImgBalloonSP03 key={`bal3-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonSPImg03} alt="" />
                </ImgBalloonSP03>
            ),
            (current: number) => (
                <ImgContainerSP04 key={`img4-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KVImgSp04} alt="" />
                </ImgContainerSP04>
            ),
            (current: number) => (
                <ImgBalloonSP04 key={`bal4-${current}`} style={{ animationDelay: '0.45s' }}>
                    <img src={KvBalloonSPImg04} alt="" />
                </ImgBalloonSP04>
            ),
        ],
        [
            (current: number) => (
                <ImgContainerSP05 key={`img5-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KVImgSp05} alt="イラスト5" />
                </ImgContainerSP05>
            ),
            (current: number) => (
                <ImgBalloonSP05 key={`bal5-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonSPImg05} alt="" />
                </ImgBalloonSP05>
            ),
            (current: number) => (
                <ImgContainerSP06 key={`img6-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KVImgSp06} alt="" />
                </ImgContainerSP06>
            ),
            (current: number) => (
                <ImgBalloonSP06 key={`bal6-${current}`} style={{ animationDelay: '0.45s' }}>
                    <img src={KvBalloonSPImg06} alt="" />
                </ImgBalloonSP06>
            ),
        ],
        [
            (current: number) => (
                <ImgContainerSP07 key={`img7-${current}`} style={{ animationDelay: '0.0s' }}>
                    <img src={KVImgSp07} alt="イラスト7" />
                </ImgContainerSP07>
            ),
            (current: number) => (
                <ImgBalloonSP07 key={`bal7-${current}`} style={{ animationDelay: '0.15s' }}>
                    <img src={KvBalloonSPImg07} alt="" />
                </ImgBalloonSP07>
            ),
            (current: number) => (
                <ImgContainerSP08 key={`img8-${current}`} style={{ animationDelay: '0.3s' }}>
                    <img src={KVImgSp08} alt="" />
                </ImgContainerSP08>
            ),
            (current: number) => (
                <ImgBalloonSP08 key={`bal8-${current}`} style={{ animationDelay: '0.45s' }}>
                    <img src={KvBalloonSPImg08} alt="" />
                </ImgBalloonSP08>
            ),
        ],
    ];
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % SETS.length);
        }, 3500);
        return () => clearInterval(timer);
    }, []);
    return (
        <>
            {SETS.map((set, idx) => (
                <FadeWrap key={idx} visible={idx === current}>
                    {idx === current && set.map((fn) => fn(current))}
                </FadeWrap>
            ))}
        </>
    );
};

export const KvPictures: React.FC = () => {
    return (
        <>
            <KvIllust>
                <Only pc>
                    <ImgContainerS01>
                        <img src={KvSImg01} alt="イラスト1" />
                    </ImgContainerS01>
                    <ImgBalloon01>
                        <img src={KvSBalloonImg01} alt="関東エリアが強いです" />
                    </ImgBalloon01>
                    <ImgContainerS02>
                        <img src={KvSImgSp02} alt="イラスト2" />
                    </ImgContainerS02>
                    <ImgBalloon02>
                        <img src={KvSBalloonImg02} alt="着手金は無料" />
                    </ImgBalloon02>
                    <ImgContainerS03>
                        <img src={KvSImgPc03} alt="イラスト3" />
                    </ImgContainerS03>
                    <ImgBalloon03>
                        <img src={KvSBalloonImg03} alt="無料で株価算定 レポート作成" />
                    </ImgBalloon03>
                    <ImgContainerS04>
                        <img src={KvSImgSp04} alt="イラスト4" />
                    </ImgContainerS04>
                    <ImgBalloon04>
                        <img src={KvSBalloonImg04} alt="社内に士業が在籍しています" />
                    </ImgBalloon04>
                </Only>
                <Only sp>
                    <KvSpSetSwitcher />
                </Only>
            </KvIllust>
        </>
    );
};
